<div class="card-container main-font">
  <p class="card-title mb-0">Feedback 360</p>

  <div
    class="empty-div w-100 d-flex justify-content-center align-items-center"
    *ngIf="!isLoading && showEmptyDiv">
    <div>Nessun feedback ricevuto</div>
  </div>

  <div *ngIf="!isLoading && !showEmptyDiv" class="w-100">
    <!-- Contenitore competenze più votate -->
    <div class="strength-container mb-16 w-100">
      <div class="strength-container-title w-100">
        <!-- Titolo -->
        <p class="mb-0 strength-title">
          I colleghi riconoscono questi punti di forza
        </p>
        <!-- Vedi tutti -->
        <button class="show-all-btn">
          <p class="mb-0 show-all-text">Vedi tutti</p>
        </button>
      </div>

      <div class="card-strength-container">
        <!-- Card punti di forza -->
        <div
          *ngFor="
            let strength of feedbackSummary.strength_points;
            let i = index
          "
          class="card-strength">
          <div class="strength-detail">
            <div class="icon-container">
              <div class="position-container">
                <p class="mb-0 counter-text">{{ i + 1 }}</p>
              </div>
              <div class="img-container">
                <img
                  [src]="utilityService.getSanitizeUrl(strength.path)"
                  [alt]="strength.alias"
                  class="strength-img" />
              </div>
            </div>
            <p class="mb-0 strength-alias">
              {{ strength.alias }}
            </p>
          </div>
          <p class="counter mb-0">{{ strength.counter }}</p>
        </div>
      </div>
    </div>

    <div class="stats-container">
      <div class="question-goal-container">
        <!-- Domande -->
        <div class="discrepancy-container">
          <div class="question-discrepancy">
            <p class="question-title-text mb-0">
              Le domande con più discrepanze
            </p>
            <div class="questions-container my-scrollbar">
              <div
                class="card-questions"
                *ngFor="let question of feedbackSummary.questions_discrepancy">
                <div class="question-detail">
                  <div class="header-question">
                    <img
                      [src]="utilityService.getSanitizeUrl(question.path)"
                      alt="question"
                      class="img-competence" />
                    <p class="mb-0 competence-text">
                      {{ question.competence_alias }}
                    </p>
                  </div>
                  <p class="mb-0 question-text">{{ question.text }}</p>
                </div>
                <div class="vote-container">
                  <div class="vote-pills">
                    <img
                      [src]="utilityService.getSanitizeUrl(question.path)"
                      alt="competence"
                      class="img-vote-competence" />
                    <p class="mb-0 text-media">{{ question.media }}</p>
                  </div>
                  <div
                    class="vote-pills"
                    [ngClass]="{
                      'vote-pills_green':
                        (+question.review_evalutaion || 0) > 0,
                      'vote-pills_red': (+question.review_evalutaion || 0) < 0
                    }">
                    <img
                      src="assets/images/icon_widget/question.svg"
                      alt="question" />
                    <p class="mb-0 text-media">
                      {{ question.review_evalutaion }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Obiettivi -->
        <div class="goals-container">
          <div class="goal-container">
            <div class="goal-title-container">
              <p class="mb-0 question-title-text">Obiettivi a breve termine</p>
              <div class="edit-container">
                <button class="show-all-btn" (click)="addGoal('goal')">
                  <img
                    src="assets/images/icon_widget/add_circle.svg"
                    alt=""
                    class="edit-icon" />
                </button>
              </div>
            </div>
            <div class="collapse-container my-scrollbar">
              <form [formGroup]="formGoal" class="w-100">
                <div formArrayName="goal">
                  <nz-collapse
                    nzAccordion
                    nzGhost
                    [nzExpandIconPosition]="'right'"
                    class="w-100 my-gap">
                    <nz-collapse-panel
                      *ngFor="let goal of goals; let i = index"
                      [formGroupName]="i"
                      [nzHeader]="titleTemplate"
                      [nzActive]="openedPanelGoalIndex === i"
                      (nzActiveChange)="onPanelToggle(i, $event)">
                      <ng-template #titleTemplate>
                        <div
                          class="d-flex justify-content-between align-items-center w-100">
                          <p class="mb-0">{{ goal.value.title }}</p>
                          <div
                            class="d-flex align-items-center"
                            *ngIf="editingGoalIndex !== i">
                            <button
                              nz-tooltip="Modifica"
                              class="show-all-btn me-2"
                              (click)="
                                editGoal('goal', i);
                                stopEventPropagation($event)
                              ">
                              <img
                                src="assets/images/icon_widget/edit.svg"
                                alt=""
                                class="edit-icon" />
                            </button>
                            <button
                              nz-tooltip="Elimina"
                              class="show-all-btn"
                              (click)="
                                deleteGoal('goal', i);
                                stopEventPropagation($event)
                              ">
                              <img
                                src="assets/images/icon_widget/trash.svg"
                                alt=""
                                class="edit-icon" />
                            </button>
                          </div>
                          <button
                            *ngIf="editingGoalIndex === i"
                            class="save-btn"
                            type="button"
                            (click)="
                              saveDescription(); stopEventPropagation($event)
                            ">
                            <p class="mb-0 save-text">Salva</p>
                          </button>
                        </div>
                      </ng-template>
                      <div *ngIf="editingGoalIndex === i; else readOnlyDesc">
                        <textarea
                          class="w-100 my-text-area"
                          formControlName="description"></textarea>
                      </div>

                      <!-- Visualizzazione solo testo -->
                      <ng-template #readOnlyDesc>
                        <p class="mb-0 goal-text ps-3">
                          {{ goal.value.description }}
                        </p>
                      </ng-template>
                    </nz-collapse-panel>
                  </nz-collapse>
                </div>
              </form>
            </div>
          </div>
          <div class="goal-container">
            <div class="goal-title-container">
              <p class="mb-0 question-title-text">Obiettivi a lungo termine</p>
              <div class="edit-container">
                <button class="show-all-btn" (click)="addGoal('growth')">
                  <img
                    src="assets/images/icon_widget/add_circle.svg"
                    alt=""
                    class="edit-icon" />
                </button>
              </div>
            </div>
            <div class="collapse-container my-scrollbar">
              <form [formGroup]="formGoal" class="w-100">
                <div formArrayName="growth">
                  <nz-collapse
                    nzAccordion
                    nzGhost
                    [nzExpandIconPosition]="'right'"
                    class="w-100 my-gap">
                    <nz-collapse-panel
                      *ngFor="let goal of growth; let i = index"
                      [formGroupName]="i"
                      [nzHeader]="titleTemplate"
                      [nzActive]="openedPanelGrowthIndex === i"
                      (nzActiveChange)="onPanelToggle(i, $event)">
                      <ng-template #titleTemplate>
                        <div
                          class="d-flex justify-content-between align-items-center w-100">
                          <p class="mb-0">{{ goal.value.title }}</p>
                          <div
                            class="d-flex align-items-center"
                            *ngIf="editingGrowthIndex !== i">
                            <button
                              nz-tooltip="Modifica"
                              class="show-all-btn me-2"
                              (click)="
                                editGoal('growth', i);
                                stopEventPropagation($event)
                              ">
                              <img
                                src="assets/images/icon_widget/edit.svg"
                                alt=""
                                class="edit-icon" />
                            </button>
                            <button
                              nz-tooltip="Elimina"
                              class="show-all-btn"
                              (click)="
                                deleteGoal('growth', i);
                                stopEventPropagation($event)
                              ">
                              <img
                                src="assets/images/icon_widget/trash.svg"
                                alt=""
                                class="edit-icon" />
                            </button>
                          </div>
                          <button
                            *ngIf="editingGrowthIndex === i"
                            class="save-btn"
                            type="button"
                            (click)="
                              saveDescription(); stopEventPropagation($event)
                            ">
                            <p class="mb-0 save-text">Salva</p>
                          </button>
                        </div>
                      </ng-template>
                      <div *ngIf="editingGrowthIndex === i; else readOnlyDesc">
                        <textarea
                          class="w-100 my-text-area"
                          formControlName="description"></textarea>
                      </div>

                      <!-- Visualizzazione solo testo -->
                      <ng-template #readOnlyDesc>
                        <p class="mb-0 goal-text ps-3">
                          {{ goal.value.description }}
                        </p>
                      </ng-template>
                    </nz-collapse-panel>
                  </nz-collapse>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="competence-container">
        <p class="question-title-text mb-0">Delta valutazioni</p>
        <div class="competence-list-container my-scrollbar">
          <div
            *ngFor="let competence of feedbackSummary.competence_discrepancy"
            class="card-competence">
            <div class="position-relative">
              <img
                [nz-tooltip]="competence.alias"
                [src]="utilityService.getSanitizeUrl(competence.path)"
                [alt]="competence.alias"
                class="competence-img"
                [ngClass]="{
                  'competence-img-positive': competence.delta > 0,
                  'competence-img-negative': competence.delta < 0
                }" />
              <div
                class="vote-percentage"
                [ngClass]="{
                  'competence-img-positive': competence.delta > 0,
                  'competence-img-negative': competence.delta < 0
                }">
                <p
                  class="mb-0 text-vote-percentage"
                  [ngClass]="{
                    'competence-img-positive': competence.delta > 0,
                    'competence-img-negative': competence.delta < 0
                  }">
                  {{ competence.delta }}%
                </p>
              </div>
            </div>
            <div class="competence-vote-container">
              <div
                class="vote-pills align-items-center justify-content-center w-100">
                <img
                  src="assets/images/people.svg"
                  alt="auto"
                  class="question-img" />
                <p class="mb-0">{{ competence.media_auto }}</p>
              </div>
              <div
                class="vote-pills align-items-center justify-content-center w-100">
                <img
                  src="assets/images/peoples.svg"
                  alt="auto"
                  class="question-img-peoples" />
                <p class="mb-0">{{ competence.media_review }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Riassunto -->
    <div class="fb360-widget_resume w-100">
      <nz-collapse
        [nzExpandIconPosition]="'right'"
        [nzAccordion]="true"
        class="mt-2 w-100">
        <nz-collapse-panel [nzHeader]="HeaderTemplate" [nzActive]="true">
          <!-- INIZIO CONTENUTO -->
          <div
            *ngIf="!isEditSummary"
            class="camillo-content custom-editor-output-css"
            [innerHTML]="feedbackSummary?.summary"></div>

          <div class="camillo-editor w-100 ms-1">
            <angular-editor
              [(ngModel)]="feedbackSummary.summary"
              *ngIf="isEditSummary"
              [config]="editorConfig"></angular-editor>
          </div>
          <!-- FINE CONTENUTO -->

          <ng-template #HeaderTemplate>
            <nz-row
              class="d-flex align-items-center w-100 ms-1"
              nzJustify="space-between">
              <!-- Camillo profile -->
              <nz-col>
                <div class="camillo">
                  <div class="camillo-say">Camillo dice</div>
                </div>
              </nz-col>
              <!-- End Camillo profile -->

              <!-- Note, Suggestion and Edit -->
              <nz-col>
                <button
                  *ngIf="!isEditSummary"
                  class="camillo-edit"
                  (click)="$event.stopPropagation(); editSummary()">
                  <img src="assets/images/Sbi/edit.svg" alt="" />
                  Modifica
                </button>

                <button
                  *ngIf="isEditSummary"
                  class="camillo-submit_btn generic-btn-disable"
                  (click)="$event.stopPropagation(); saveSummary()">
                  Salva
                </button>
              </nz-col>
              <!-- End Note, Suggestion and Edit -->
            </nz-row>
          </ng-template>
        </nz-collapse-panel>
      </nz-collapse>
    </div>
  </div>

  <ng-template [ngIf]="isLoading">
    <nz-skeleton [nzActive]="true" [nzParagraph]="{ rows: 8 }"></nz-skeleton>
  </ng-template>
</div>
